import { useState, useCallback } from 'react';

// Year/FY filter state persisted per user in localStorage.
// Default is '' = "All Years"; switching to a specific year sticks across reloads.
export default function usePersistedFilter(key, initial = '') {
  const [val, setVal] = useState(() => {
    try {
      const s = localStorage.getItem(key);
      return s !== null ? s : initial;
    } catch { return initial; }
  });
  const set = useCallback(v => {
    setVal(v);
    try { localStorage.setItem(key, v); } catch {}
  }, [key]);
  return [val, set];
}
